import billingInvoicesService from "../../../apis/services/admin/billingInvoicesService";
import {
  FETCH_BILLING_INVOICES_ATTEMPT,
  FETCH_BILLING_INVOICES_SUCCESS,
  FETCH_BILLING_INVOICES_ERROR,
  FETCH_BILLING_INVOICE_ATTEMPT,
  FETCH_BILLING_INVOICE_SUCCESS,
  FETCH_BILLING_INVOICE_ERROR,
  FETCH_BILLING_INVOICE_RESET_STATE,
  CREATE_BILLING_INVOICE_ATTEMPT,
  CREATE_BILLING_INVOICE_SUCCESS,
  CREATE_BILLING_INVOICE_ERROR,
  CREATE_BILLING_INVOICE_RESET_STATE,
  UPDATE_BILLING_INVOICE_ATTEMPT,
  UPDATE_BILLING_INVOICE_SUCCESS,
  UPDATE_BILLING_INVOICE_ERROR,
  UPDATE_BILLING_INVOICE_RESET_STATE,
  UPDATE_BILLING_INVOICE_REFERENCE_ATTEMPT,
  UPDATE_BILLING_INVOICE_REFERENCE_SUCCESS,
  UPDATE_BILLING_INVOICE_REFERENCE_ERROR,
  UPDATE_BILLING_INVOICE_REFERENCE_RESET_STATE,
  SEND_BILLING_INVOICE_ATTEMPT,
  SEND_BILLING_INVOICE_SUCCESS,
  SEND_BILLING_INVOICE_ERROR,
  SEND_BILLING_INVOICE_RESET_STATE,
  CANCEL_BILLING_INVOICE_ATTEMPT,
  CANCEL_BILLING_INVOICE_SUCCESS,
  CANCEL_BILLING_INVOICE_ERROR,
  CANCEL_BILLING_INVOICE_RESET_STATE,
  TOGGLE_BILLING_INVOICE_PAID_ATTEMPT,
  TOGGLE_BILLING_INVOICE_PAID_SUCCESS,
  TOGGLE_BILLING_INVOICE_PAID_ERROR,
  TOGGLE_BILLING_INVOICE_PAID_RESET_STATE,
  GENERATE_ALL_BILLING_INVOICES_ATTEMPT,
  GENERATE_ALL_BILLING_INVOICES_SUCCESS,
  GENERATE_ALL_BILLING_INVOICES_ERROR,
  GENERATE_ALL_BILLING_INVOICES_RESET_STATE,
  FETCH_BILLING_INVOICE_ITEMS_ATTEMPT,
  FETCH_BILLING_INVOICE_ITEMS_SUCCESS,
  FETCH_BILLING_INVOICE_ITEMS_ERROR,
  CREATE_BILLING_INVOICE_ITEM_ATTEMPT,
  CREATE_BILLING_INVOICE_ITEM_SUCCESS,
  CREATE_BILLING_INVOICE_ITEM_ERROR,
  CREATE_BILLING_INVOICE_ITEM_RESET_STATE,
  UPDATE_BILLING_INVOICE_ITEM_ATTEMPT,
  UPDATE_BILLING_INVOICE_ITEM_SUCCESS,
  UPDATE_BILLING_INVOICE_ITEM_ERROR,
  UPDATE_BILLING_INVOICE_ITEM_RESET_STATE,
  DELETE_BILLING_INVOICE_ITEM_ATTEMPT,
  DELETE_BILLING_INVOICE_ITEM_SUCCESS,
  DELETE_BILLING_INVOICE_ITEM_ERROR,
  DELETE_BILLING_INVOICE_ITEM_RESET_STATE,
  FETCH_BILLING_INVOICE_PAYMENTS_ATTEMPT,
  FETCH_BILLING_INVOICE_PAYMENTS_SUCCESS,
  FETCH_BILLING_INVOICE_PAYMENTS_ERROR,
  CREATE_BILLING_INVOICE_PAYMENT_ATTEMPT,
  CREATE_BILLING_INVOICE_PAYMENT_SUCCESS,
  CREATE_BILLING_INVOICE_PAYMENT_ERROR,
  CREATE_BILLING_INVOICE_PAYMENT_RESET_STATE,
  UPDATE_BILLING_INVOICE_PAYMENT_ATTEMPT,
  UPDATE_BILLING_INVOICE_PAYMENT_SUCCESS,
  UPDATE_BILLING_INVOICE_PAYMENT_ERROR,
  UPDATE_BILLING_INVOICE_PAYMENT_RESET_STATE,
  DELETE_BILLING_INVOICE_PAYMENT_ATTEMPT,
  DELETE_BILLING_INVOICE_PAYMENT_SUCCESS,
  DELETE_BILLING_INVOICE_PAYMENT_ERROR,
  DELETE_BILLING_INVOICE_PAYMENT_RESET_STATE,
  BULK_CREATE_BILLING_INVOICES_ATTEMPT,
  BULK_CREATE_BILLING_INVOICES_SUCCESS,
  BULK_CREATE_BILLING_INVOICES_ERROR,
  BULK_CREATE_BILLING_INVOICES_RESET_STATE,
  FETCH_INVOICE_SCHEMA_IDS_ATTEMPT,
  FETCH_INVOICE_SCHEMA_IDS_SUCCESS,
  FETCH_INVOICE_SCHEMA_IDS_ERROR,
  SELECT_INVOICE_SCHEMA,
  SELECT_ALL_INVOICE_SCHEMAS,
} from "../../actionTypes/actionTypes";

// Billing Invoices
export const fetchBillingInvoices = (page = 1, perPage = 20, companyId = null, status = null, searchTerm = "", billingPeriodStart = null, billingPeriodEnd = null, isPaid = null) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_BILLING_INVOICES_ATTEMPT });
    try {
      const response = await billingInvoicesService.getBillingInvoices(page, perPage, companyId, status, searchTerm, billingPeriodStart, billingPeriodEnd, isPaid);
      dispatch({
        type: FETCH_BILLING_INVOICES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_BILLING_INVOICES_ERROR,
        payload: error,
      });
    }
  };
};

export const fetchBillingInvoice = (id) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_BILLING_INVOICE_ATTEMPT });
    try {
      const response = await billingInvoicesService.getBillingInvoice(id);
      dispatch({
        type: FETCH_BILLING_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_BILLING_INVOICE_ERROR,
        payload: error,
      });
    }
  };
};

export const fetchBillingInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_BILLING_INVOICE_RESET_STATE });
  };
};

export const createBillingInvoice = (invoiceData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_BILLING_INVOICE_ATTEMPT });
    try {
      const response = await billingInvoicesService.createBillingInvoice(invoiceData);
      dispatch({
        type: CREATE_BILLING_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_BILLING_INVOICE_ERROR,
        payload: error,
      });
    }
  };
};

export const createBillingInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: CREATE_BILLING_INVOICE_RESET_STATE });
  };
};

export const updateBillingInvoice = (id, invoiceData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_ATTEMPT });
    try {
      const response = await billingInvoicesService.updateBillingInvoice(id, invoiceData);
      dispatch({
        type: UPDATE_BILLING_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_BILLING_INVOICE_ERROR,
        payload: error,
      });
    }
  };
};

export const updateBillingInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_RESET_STATE });
  };
};

export const updateBillingInvoiceReference = (id, reference) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_REFERENCE_ATTEMPT });
    try {
      const response = await billingInvoicesService.updateBillingInvoiceReference(id, reference);
      dispatch({
        type: UPDATE_BILLING_INVOICE_REFERENCE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_BILLING_INVOICE_REFERENCE_ERROR,
        payload: error,
      });
    }
  };
};

export const updateBillingInvoiceReferenceResetState = () => {
  return (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_REFERENCE_RESET_STATE });
  };
};

export const sendBillingInvoice = (id) => {
  return async (dispatch) => {
    dispatch({ type: SEND_BILLING_INVOICE_ATTEMPT });
    try {
      const response = await billingInvoicesService.sendBillingInvoice(id);
      dispatch({
        type: SEND_BILLING_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: SEND_BILLING_INVOICE_ERROR,
        payload: error,
      });
    }
  };
};

export const sendBillingInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: SEND_BILLING_INVOICE_RESET_STATE });
  };
};

export const cancelBillingInvoice = (id) => {
  return async (dispatch) => {
    dispatch({ type: CANCEL_BILLING_INVOICE_ATTEMPT });
    try {
      const response = await billingInvoicesService.cancelBillingInvoice(id);
      dispatch({
        type: CANCEL_BILLING_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CANCEL_BILLING_INVOICE_ERROR,
        payload: error,
      });
    }
  };
};

export const cancelBillingInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: CANCEL_BILLING_INVOICE_RESET_STATE });
  };
};

export const togglePaidBillingInvoice = (id) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_BILLING_INVOICE_PAID_ATTEMPT });
    try {
      const response = await billingInvoicesService.togglePaidBillingInvoice(id);
      dispatch({
        type: TOGGLE_BILLING_INVOICE_PAID_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: TOGGLE_BILLING_INVOICE_PAID_ERROR,
        payload: error,
      });
    }
  };
};

export const togglePaidBillingInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_BILLING_INVOICE_PAID_RESET_STATE });
  };
};

export const generateAllBillingInvoices = () => {
  return async (dispatch) => {
    dispatch({ type: GENERATE_ALL_BILLING_INVOICES_ATTEMPT });
    try {
      const response = await billingInvoicesService.generateAllBillingInvoices();
      dispatch({
        type: GENERATE_ALL_BILLING_INVOICES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: GENERATE_ALL_BILLING_INVOICES_ERROR,
        payload: error,
      });
    }
  };
};

export const generateAllBillingInvoicesResetState = () => {
  return (dispatch) => {
    dispatch({ type: GENERATE_ALL_BILLING_INVOICES_RESET_STATE });
  };
};

// Billing Invoice Items
export const fetchBillingInvoiceItems = (id) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_BILLING_INVOICE_ITEMS_ATTEMPT });
    try {
      const response = await billingInvoicesService.getInvoiceItems(id);
      dispatch({
        type: FETCH_BILLING_INVOICE_ITEMS_SUCCESS,
        payload: { invoiceId: id, items: response.data },
      });
    } catch (error) {
      dispatch({
        type: FETCH_BILLING_INVOICE_ITEMS_ERROR,
        payload: error,
      });
    }
  };
};

export const createBillingInvoiceItem = (id, itemData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_BILLING_INVOICE_ITEM_ATTEMPT });
    try {
      const response = await billingInvoicesService.createInvoiceItem(id, itemData);
      dispatch({
        type: CREATE_BILLING_INVOICE_ITEM_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_BILLING_INVOICE_ITEM_ERROR,
        payload: error,
      });
    }
  };
};

export const createBillingInvoiceItemResetState = () => {
  return (dispatch) => {
    dispatch({ type: CREATE_BILLING_INVOICE_ITEM_RESET_STATE });
  };
};

export const updateBillingInvoiceItem = (id, itemId, itemData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_ITEM_ATTEMPT });
    try {
      const response = await billingInvoicesService.updateInvoiceItem(id, itemId, itemData);
      dispatch({
        type: UPDATE_BILLING_INVOICE_ITEM_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_BILLING_INVOICE_ITEM_ERROR,
        payload: error,
      });
    }
  };
};

export const updateBillingInvoiceItemResetState = () => {
  return (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_ITEM_RESET_STATE });
  };
};

export const deleteBillingInvoiceItem = (id, itemId) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_BILLING_INVOICE_ITEM_ATTEMPT });
    try {
      await billingInvoicesService.deleteInvoiceItem(id, itemId);
      dispatch({
        type: DELETE_BILLING_INVOICE_ITEM_SUCCESS,
        payload: { invoiceId: id, itemId },
      });
    } catch (error) {
      dispatch({
        type: DELETE_BILLING_INVOICE_ITEM_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteBillingInvoiceItemResetState = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_BILLING_INVOICE_ITEM_RESET_STATE });
  };
};

// Billing Invoice Payments
export const fetchBillingInvoicePayments = (id) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_BILLING_INVOICE_PAYMENTS_ATTEMPT });
    try {
      const response = await billingInvoicesService.getInvoicePayments(id);
      dispatch({
        type: FETCH_BILLING_INVOICE_PAYMENTS_SUCCESS,
        payload: { invoiceId: id, ...response.data },
      });
    } catch (error) {
      dispatch({
        type: FETCH_BILLING_INVOICE_PAYMENTS_ERROR,
        payload: error,
      });
    }
  };
};

export const createBillingInvoicePayment = (id, paymentData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_BILLING_INVOICE_PAYMENT_ATTEMPT });
    try {
      const response = await billingInvoicesService.createInvoicePayment(id, paymentData);
      dispatch({
        type: CREATE_BILLING_INVOICE_PAYMENT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_BILLING_INVOICE_PAYMENT_ERROR,
        payload: error,
      });
    }
  };
};

export const createBillingInvoicePaymentResetState = () => {
  return (dispatch) => {
    dispatch({ type: CREATE_BILLING_INVOICE_PAYMENT_RESET_STATE });
  };
};

export const updateBillingInvoicePayment = (id, paymentId, paymentData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_PAYMENT_ATTEMPT });
    try {
      const response = await billingInvoicesService.updateInvoicePayment(id, paymentId, paymentData);
      dispatch({
        type: UPDATE_BILLING_INVOICE_PAYMENT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_BILLING_INVOICE_PAYMENT_ERROR,
        payload: error,
      });
    }
  };
};

export const updateBillingInvoicePaymentResetState = () => {
  return (dispatch) => {
    dispatch({ type: UPDATE_BILLING_INVOICE_PAYMENT_RESET_STATE });
  };
};

export const deleteBillingInvoicePayment = (id, paymentId) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_BILLING_INVOICE_PAYMENT_ATTEMPT });
    try {
      await billingInvoicesService.deleteInvoicePayment(id, paymentId);
      dispatch({
        type: DELETE_BILLING_INVOICE_PAYMENT_SUCCESS,
        payload: { invoiceId: id, paymentId },
      });
    } catch (error) {
      dispatch({
        type: DELETE_BILLING_INVOICE_PAYMENT_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteBillingInvoicePaymentResetState = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_BILLING_INVOICE_PAYMENT_RESET_STATE });
  };
};

// Bulk Create Billing Invoices
export const bulkCreateBillingInvoices = (bulkData) => {
  return async (dispatch) => {
    dispatch({ type: BULK_CREATE_BILLING_INVOICES_ATTEMPT });
    try {
      const response = await billingInvoicesService.bulkCreateBillingInvoices(bulkData);
      // Service already returns response.data, so use it directly
      dispatch({
        type: BULK_CREATE_BILLING_INVOICES_SUCCESS,
        payload: response.data || response,
      });
    } catch (error) {
      dispatch({
        type: BULK_CREATE_BILLING_INVOICES_ERROR,
        payload: error,
      });
    }
  };
};

export const bulkCreateBillingInvoicesResetState = () => {
  return (dispatch) => {
    dispatch({ type: BULK_CREATE_BILLING_INVOICES_RESET_STATE });
  };
};

export const fetchInvoiceSchemaIds = (isActive = null) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_INVOICE_SCHEMA_IDS_ATTEMPT });
    try {
      const response = await billingInvoicesService.getInvoiceSchemaIds(isActive);
      dispatch({
        type: FETCH_INVOICE_SCHEMA_IDS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_INVOICE_SCHEMA_IDS_ERROR,
        payload: error,
      });
    }
  };
};

export const selectInvoiceSchema = (schema) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_INVOICE_SCHEMA,
      payload: { data: schema },
    });
  };
};

export const selectAllInvoiceSchemas = (select, allSchemaIds = []) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_ALL_INVOICE_SCHEMAS,
      payload: { data: select, allSchemaIds },
    });
  };
};

